// extracted by mini-css-extract-plugin
module.exports = {"downloadLink":"servicesDownload_downloadLink__xNTNP sharedStyles_remove-link-style__2b0q-"};